export const fontColor = '#f2f2f2';

export const primaryColor = '#ff8000';

export const parentContainer = {
	flexGrow: 1
};

export const textBlack = '#000';

export const textPrimary = '#ff8000';

export const textGrey = '#535353';

export const webFont = 'Poppins';

